import React, { useEffect } from 'react'
import '../index.css';
import { useNotification } from '../context/NotificationContext.js';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';
import { Trash2 } from 'lucide-react';



    function formatDate(isoString) {
        const date = new Date(isoString);
    
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        };
    
        return date.toLocaleString('en-US', options);
    }

const NotificationComp = () => {
    const {user} = useAuth();

    const navigate = useNavigate()

    const {getAllNotifications, notificationData, getNotificationForUser, markAsRead, deleteNotification} = useNotification()


    useEffect(() => {
        getNotificationForUser(user.id)
    }, [])


    async function handleMarkRead(id, status ){
        if(parseInt(status) === 0){
                const newStatus = 1;
            const data = {
                status : newStatus
            }
            await markAsRead(id, data)
        }else{
            return null
        }

    }
    async function handleDelete(id, status ){
        if(parseInt(status) === 0){
                const newStatus = 1;
            const data = {
                status : newStatus
            }
            await deleteNotification(id, data);
            await getNotificationForUser(user.id)

        }else{
            return null
        }

    }

    
  return (
    <div className='personal-properties-container margin-top'>
        <section class="notification-bar margin-top2">
            <h3>Notifications</h3>
            <ul class="notifications" id="notifications">
                {
                    notificationData?.filter(notify => parseInt(notify.ns_isdeleted) === 0 ).map(notify => (
                        // <Link to= {notify.url} >
                        //     <li className='notify-text'>{notify.message}</li>

                        // </Link>

                        <li className={parseInt(notify.ns_isread) === 0 ? 'notification-item' : 'notification-item-read'}>
                            <Link onClick={() => handleMarkRead(notify.ns_id, notify.ns_isread)} to={notify.url} className='notification-link'>
                                <span className='notification-message'>{notify.message}</span>
                                <span className='notification-message'>{formatDate(notify.created_at)}</span>
                            </Link>
                            <button className='notification-delete' onClick={() => handleDelete(notify.ns_id, notify.ns_isdeleted)}>
                                <Trash2 size={18} />
                            </button>
                        </li>
                    ))
                }
            </ul>
        </section>
    </div>
  )
}

export default NotificationComp